export default __webpack_public_path__ + "static/media/account-number.d80ae643.svg";